export default "__VITE_ASSET__0367c1a9__"